import { z } from 'zod'

/**
 * Featured TLD configuration from GET /admin/tlds/featured
 */
export const FeaturedTLDConfig = z.object({
  id: z.number(),
  tld: z.string(),
  category: z.string(),
  display_order: z.number(),
  enabled: z.boolean()
})

export type FeaturedTLDConfig = z.infer<typeof FeaturedTLDConfig>

/**
 * Request body for POST /admin/tlds/featured (upsert)
 */
export const FeaturedTLDRequest = z.object({
  tld: z.string(),
  category: z.string().optional(),
  display_order: z.number().optional(),
  enabled: z.boolean().optional()
})

export type FeaturedTLDRequest = z.infer<typeof FeaturedTLDRequest>
